import { useState, useEffect, useRef, useContext } from 'react'
import axios from 'axios'

import { loadingContext, projectContext, urlValue, unfolder, onImportExcelAsync,openAlert, useTranslate } from '../../lib'
import SelectCodeModal from '../SelectCodeModal'
import '../../styles/sideIntent.scss'
import '../../styles/styles.css'
import { useForm } from 'react-hook-form'

import Loading from '../Loading'
import Swal from 'sweetalert2'
import { Tooltip } from 'react-tooltip'
import BoxInfo from '../common/BoxInfo'
import { Alerts } from '../common/Alerts'
import Button from '../provider/button/button.jsx'
import H2 from '../provider/h2/H2.jsx'
import H3 from '../provider/h3/H3.jsx'
import H4 from '../provider/h4/H4.jsx'

export function NewIntent({ setSidePanel, refresh, setRefresh, update }) {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [isModalOpen, setIsModalOpen] = useState({ delete: false, code: false })
  const [loading, setLoading] = useContext(loadingContext)
  const [answer, setAnswer] = useState()
  const [category, setCategory] = useState()
  const [compliancePhare, setCompliancePhare] = useState("")
  const [multi_phrase, setMulti_phrase] = useState([])

  const [list, setList] = useState([])
  const phraseInput = useRef()
  const nameInput = useRef()
  const dummy = useRef()
  const input_ref = useRef()
  const output_ref = useRef()
  const [errors, setErrors] = useState({ name: "" })
  const [alert, setAlert] = useState({title: '', visible: false})
  let phrase = useRef('')
  let name = useRef('')
  const [inputContext, setInputContext] = useState()

  let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
  let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
  let user_id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
  let ccms_name = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').ccms_name
  const { t } = useTranslate();
  
  useEffect(() => {
    setMulti_phrase([]);
  }, [])
  
  String.prototype.rtrim = function () {
    //removes last space from string when invoked
    return this.replace(/((\s*\S+)*)\s*/, '$1')
  }

  const handleCancel = () => {
    cleanForm()
    update();    
  }

  const Submit = e => {
    e.preventDefault()

    let ok = true
    const exp = /^[A-Za-zÀ-ÿ0-9-,._-ñ;!@'()-¿?\s]+$/g;
    const exp_spaces = /\s/g;
    if (!exp.test(nameInput.current.value)) {
      ok = false;
      setErrors({ ...errors, name: t('errors.nameInvalid') })
    }
    const input_context = document.querySelector("#input-context").value;
    const output_context = document.querySelector("#output-context").value;

    if (category == null && compliancePhare == "") {
      ok = false
      setErrors({ ...errors, name: t('errors.intentCategoryAndMainSentenceRequired') })
    }

    else if (category == null) {
      ok = false
      setErrors({ ...errors, name: t('errors.intentCategoryRequired') })
    }

    else if (compliancePhare === "") {
      ok = false
      setErrors({ ...errors, name: t('errors.intentMainSentenceRequired') })
    }

    if (ok) {
      setLoading(true)
      
      axios({
        method: 'post',
        url: `${urlValue}/studio/project/${selectedProject.id}/intent`,
        headers: {
          'access-token': token,
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
        data: JSON.stringify({
          displayName: name.current.rtrim(),
          trainingPhrasesParts: list,
          languageCode: selectedProject?.metadata?.language?.slice(0,2),

          multi_phrase,
          compliance_type: category,
          compliance_phare: compliancePhare,
          inputContext: input_context,
          outputContext: output_context,
          user_id: user_id.toString(),
          ccms_name: ccms_name.toString(),
        }),
      })
        .then(function (response) {
          setAnswer(response.data)
          // setList([])
          // nameInput.current.value = ''
          cleanForm();
          update();
          setLoading(false) 
          // setRefresh(refresh + 1)
          openAlert('#alert-ac', () => {setAlert({title: t('alerts.intentCreated'), visible: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
   
        })
        .catch(function (error) {
          console.log(error)
          setLoading(false)
          openAlert('#alert-ac', () => {setAlert({title: t('alerts.intentNotSaved'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
         
        })
    }
  }

  const handleIntro = e => {
    if (e.key == 'Enter') {
      addPhrase(e)
    }
  }
  const addPhrase = e => {
    e.preventDefault()
    let ok = true
    const exp = /^[A-Za-zÀ-ÿ0-9-,._-ñ;!@'()-¿?\s]+$/g;
    if (!exp.test(phraseInput.current.value)) {
      openAlert('#alert-ac', () => {setAlert({title: t('alerts.intentPhraseInvalidChars'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
      ok = false;
    }

    if (phraseInput.current.value.length > 768) {
      openAlert('#alert-ac', () => {setAlert({title: t('alerts.intentPhraseTooLong'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
      ok = false;
    }

    if (ok) {
      setList(prev => [...prev, phrase.current.rtrim()])
      phraseInput.current.value = ''
    }

  }
  const removePhrase = e => {
    e.preventDefault()
    let end = e.target.previousSibling.innerText.length
    let element = e.target.previousSibling.innerText.slice(2, end)
    setList(prev => prev.filter(e => e !== element))
  }
  const removePhrase2 = (index, phrase) => {
    setList(prev => prev.filter((e, i) => i !== index))
    setMulti_phrase(prev => prev.filter(x => x !== phrase))
  }

  useEffect(() => {
    if (dummy.current) {
      // dummy.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [list])

  const changeCategory = e => {
    document.querySelectorAll(".categories_list .checkbox").forEach(element => element.checked = false);
    e.target.checked = true;
    switch (e.target.id) {
      case "compliance":
        setCategory(1);
        break;
      case "resolution":
        setCategory(2);
        break;
      case "conversation":
        setCategory(3);
        break;
      case "disclaimer":
        setCategory(4);
        break;
      default:
        break;
    }
  }

  const changePhrase = (e, phrase) => {

    if (e.target.checked) {
      setMulti_phrase([...multi_phrase, phrase])
    } else {
      setMulti_phrase(prev => prev.filter(x => x !== phrase))
    }
    if (category === 4) {
      document.querySelectorAll(".newPhrases .checkbox").forEach(element => element.checked = false);
      e.target.checked = true;
      setMulti_phrase([phrase])
    }
    setCompliancePhare(phrase);
  }
  const [IntentstExcel, setIntentstExcel] = useState([]);
  const [loadingUpload, setLoadingUpload] = useState(false)


  const uploadMaxive = async () => {

    if (!loadingUpload && IntentstExcel.length > 0 && IntentstExcel.length <= 101) {

      setLoadingUpload(true)
      setTimeout(async () => {

        const DatosFormat = [...IntentstExcel].map((item, index) => {
          let split = item.Training_Phrases.split("--");
          split = split.filter(x => x.trim() !== "");
          const fraseSelecionada = split.find(x => x[0] === "*");
          split = split.map(ph => (ph.replace("*", "")?.trim()));
          return { ...item, Training_Phrases: split, CompliancePhare: fraseSelecionada.replace("*", "")?.trim() };
        });
        for (var i = 0; i < DatosFormat.length; i++) {

          let CategoryExcel = 1;
          switch (DatosFormat[i].Category) {
            case "Compliance":
              CategoryExcel = 1;
              break;
            case "Resolution":
              CategoryExcel = 2;
              break;
            case "Conversation":
              CategoryExcel = 3;
              break;

            default:
              break;
          }
          const dataSend = JSON.stringify({
            displayName: DatosFormat[i].Name?.trim(),
            trainingPhrasesParts: DatosFormat[i].Training_Phrases,
            languageCode: selectedProject?.metadata?.language?.slice(0,2),
            compliance_type: CategoryExcel,
            compliance_phare: DatosFormat[i].CompliancePhare,
          })
          const rest = await axios.post(`${urlValue}/studio/project/${selectedProject.id}/intent`,
            dataSend,
            {
              headers: {
                'access-token': token,
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': true,
                'X-CSRF-Token': csrfToken
            },
            withCredentials: true,

            })
        }
        setLoadingUpload(false)
        window.location.reload();
      }, 2000)

    } else {
      alert(t('alerts.intentExcelLimit'))
    }

  }
  const prepareExcel = async (file) => {
    const DatosExcel = await onImportExcelAsync(file);
    setIntentstExcel(DatosExcel);
    uploadMaxive();

  }
  const cleanForm = () => {
    setList([])
    nameInput.current.value = ''
    setErrors({ ...errors, name: "" })
    document.querySelectorAll(".categories_list .checkbox").forEach(element => element.checked = false);
    setCompliancePhare("")
    setMulti_phrase([])
    input_ref.current.value = ''
    output_ref.current.value = ''
    phraseInput.current.value = ''
  }

  const changePhraseName = (e, index) => {
    if (e.target.value) {
      const multiNew = [...multi_phrase]
      if (compliancePhare === multiNew[index])
        setCompliancePhare(e.target.value);

      multiNew[index] = e.target.value;
      setMulti_phrase(multiNew)
    } 
  }

  useEffect(() => {
    setTimeout(() => {
    let textareas = document.querySelectorAll(".box-text")
   
      textareas.forEach((element) => {
        element.style.height = `${element.scrollHeight}px`
      
    })    
  }, 400)
  }, [])
  return (
    <div className="newIntent editIntent" id="intents">
      <div className="Intent">
        <div className="  scroll-internal-intents ">
          <div className="IntTitle">
            <H2 text={t('intents.createTitle')} />
          </div>
          <form className="form_intent_create" onKeyPress={handleIntro} onSubmit={Submit}>
            <input id="csrf" type="hidden" name="_csrf" value="{{csrfToken}}" />
            <div className=" ">

              <div className="flex ">
                <div className="con_name flex-1">
                  <BoxInfo
                      id="intent-name"
                      titleClass='mr-0-4 f-16  title-intent'
                      title={t('common.name') + ':'}
                      place="top"
                      containerClass='mr-0-5 z-15 '
                      render={`<div>
                          ${t('intents.intentNameInfo')}
                        </div>`}
                    />
                  <input
                    id='name-tp'
                    type="text"
                    placeholder={t('intents.intentNamePlaceholder')}
                    className='input-data'
                    onChange={e => (name.current = e.target.value.toUpperCase())}
                    ref={nameInput}
                  />
                  <Tooltip anchorSelect="#name-tp" content={t('alerts.charactersNameTooltip')} place={"top"} />
                </div>

                <div className="flex-1">
                  <div className="con_categories">
                    <BoxInfo
                      id="ramvoice-tp"
                      titleClass='mr-0-4 f-16  title-intent'
                      title={t('intents.category') + ':'}
                      place="top"
                      containerClass='mr-0-5 z-15 '
                      render={`<div>
                          ${t('intents.categoryInfo')}
                        </div>`}
                    />
                    <div className="categories_list">
                      <div className="item">
                        <input id="compliance" type="checkbox" className="checkbox" onChange={changeCategory} />
                        <label htmlFor="compliance" className='sub-title-intent'>{t('reports.compliance')}</label>
                      </div>
                      <div className="item">
                        <input id="resolution" type="checkbox" className="checkbox" onChange={changeCategory} />
                        <label htmlFor="resolution" className='sub-title-intent'>{t('reports.resolution')}</label>
                      </div>
                      <div className="item">
                        <input id="conversation" type="checkbox" className="checkbox" onChange={changeCategory} />
                        <label htmlFor="conversation" className='sub-title-intent'>{t('common.conversation')}</label>
                      </div>
                      <div className="item">
                        <input id="disclaimer" type="checkbox" className="checkbox" onChange={changeCategory} />
                        <label htmlFor="disclaimer" className='sub-title-intent'>{t('reports.disclaimer')}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="w-full ">
                <BoxInfo
                  id="intent-context"
                  titleClass='mr-0-4 f-16 title-intent'
                  title={t('intents.context') + ':'}
                  place="top"
                  containerClass='mr-0-5 z-15 '
                  render={`<div>
                      ${t('intents.contextInfoNew')}
                    </div>`}
                />

                <div className='flex items-center mt-2'>
                  <div className="con_name">
                    <BoxInfo
                      id="input-context"
                      titleClass='mr-0-4 f-16 title-intent'
                      title={t('intents.inputContext') + ':'} titleStyle={{fontWeight: '400'}}
                      place="top"
                      containerClass='mr-0-5 z-15'
                      render={`<div>
                          ${t('intents.inputContextInfo')}
                        </div>`}
                    />
                    <input
                      id="input-context"
                      ref={input_ref}
                      type="text"
                      className='input-data'
                      onChange={() => { }}
                    />
                  </div>

                  <div className="con_name" style={{ marginLeft: 7 }}>
                    <BoxInfo
                      id="output-context"
                      titleClass='mr-0-4 f-16 title-intent'
                      title={t('intents.outputContext') + ':'} titleStyle={{fontWeight: '400'}}
                      place="top"
                      containerClass='mr-0-5 z-15'
                      render={`<div>
                          ${t('intents.outputContextInfo')}
                        </div>`}
                    />
                    <input
                      ref={output_ref}
                      id="output-context"
                      type="text"
                      className='input-data'
                      onChange={() => { }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="con_training_phrases">
              <BoxInfo
                  id="intent-training-phrases"
                  titleClass='mr-0-4 f-16 title-intent'
                  title={t('intents.trainingPhrases')}
                  place="top"
                  containerClass='mr-0-5 z-15 '
                  render={`<div>
                      ${t('intents.trainingPhrasesInfo')}
                    </div>`}
                />

              <div className="addPhrase  ">
                <input
                  id='train-tp'
                  type="text"
                  placeholder={t('intents.trainingPhrasesPlaceholder')}
                  ref={phraseInput}
                  className='input-data'
                  onChange={e => (phrase.current = e.target.value)}
                />
                {/* <span className="tooltiptext">Only these characters are accepted A-Za-z0-9-,._'¿? <div className='triangulo'></div></span> */}
                <Tooltip anchorSelect="#train-tp" content={t('alerts.charactersNameTooltip')} place={"top"} />
                <img id="add-tp" alt='' onClick={addPhrase} src="/icons/add-icon-nt.png" style={{ width: 52, height: 28, objectFit: 'contain', cursor: 'pointer' }} />
                {/* <a onClick={addPhrase} className="addsOrSubs">
              </a> */}
                <Tooltip anchorSelect="#add-tp" content={t('intents.addPhraseTooltip')} place={"top"} />
              </div>

              {list.length !== 0 && (
                <div className="newPhrases" style={{ overflowY: "hidden" }}>
                  <div className="sub-phrase-scroll">
                    {list.map((element, index) => (
                      <div className="rendered" key={index}>
                      <textarea phrase={element} defaultValue={element} className='edit-input box-text' style={{border:'none', resize: 'none', width: "100%", marginRight: 7, }} onChange={(e) => changePhraseName(e, index)}  ></textarea>
                      {/* <input type="text" phrase={element} defaultValue={element} className='edit-input' style={{marginRight: 7}} onChange={(e) => changePhraseName(e, index)} /> */}
                        <div className="phrase_selection">
                          {/* <img alt="" src={'/icons/edit-icon.png'}  className="edit-icon-phrase"/> */}
                          <input type="checkbox" className="checkbox" id='phrase_selection_checkbox' onChange={(e) => changePhrase(e, element)} />
                          <Tooltip anchorSelect="#phrase_selection_checkbox" content={t('intents.selectMainSentenceTooltip')} place={"top"} />
                          <a className="addsOrSubs" id="phrase_selection_delete" onClick={() => removePhrase2(index, element)} >
                            -
                          </a>
                          <Tooltip anchorSelect="#phrase_selection_delete" content={t('common.delete')} place={"top"} />
                        </div>

                      </div>
                    ))}
                    <div ref={dummy}></div>
                  </div>
                </div>
              )}
            </div>

            <div className="buttons">
              {/* <button className="blue-secondary" onClick={handleCancel}>
              Cancel
            </button> */}

              <Button 
                type="button"
                id='cancel-tp'
                label={t('common.cancel')}
                onClick={(handleCancel)}
                className="create btn-bottom btn-bottom-cancel"
                content={t('intents.cancelCreation')}
              />

              <button id='save-tp' className="create btn-bottom btn-bottom-create" style={{ marginLeft: 10, minWidth: "auto" }}>{t('common.create')}</button>
              <Tooltip anchorSelect="#save-tp" content={t('intents.createTooltip')} place={"top"} />
            </div>
            <span className='errors-msg'  >{errors.name}</span>
          </form>
        </div>
        <SelectCodeModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          setValue={setInputContext}
        />
      </div>
      {alert.visible && <Alerts id="alert-ac" title={alert.title} error={alert.error} />}
    </div>
  )
}
